import { render, staticRenderFns } from "./ModalPrintSticker.vue?vue&type=template&id=08afc2a6&scoped=true&"
import script from "./ModalPrintSticker.vue?vue&type=script&lang=js&"
export * from "./ModalPrintSticker.vue?vue&type=script&lang=js&"
import style0 from "./ModalPrintSticker.vue?vue&type=style&index=0&id=08afc2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08afc2a6",
  null
  
)

export default component.exports